import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FlowManagerService } from '../shared/services/flowmanager.service';

@Injectable()
export class GetKBACanActivate implements CanActivate {

  constructor(
    flowManager: FlowManagerService,
    router: Router
  ) {
    this.flowManager = flowManager;
    this.router = router;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.flowManager.isAuthed === true || this.flowManager.completedCipForm === true) {
      this.router.navigate(['/employment-info'], { queryParamsHandling: 'preserve' });
      return false;
    } else {
      return true;
    }
  }
}
